var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProblemWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m496.136719 291.480469-151-242c-19.332031-30.984375-52.65625-49.480469-89.136719-49.480469s-69.804688 18.496094-89.136719 49.480469l-151 242c-10.378906 16.632812-15.863281 35.832031-15.863281 55.519531 0 57.898438 47.101562 105 105 105h302c57.898438 0 105-47.101562 105-105 0-19.6875-5.484375-38.886719-15.863281-55.519531zm-89.136719 130.519531h-302c-41.355469 0-75-33.644531-75-75 0-14.066406 3.914062-27.773438 11.316406-39.636719l151-242c13.816406-22.144531 37.621094-35.363281 63.683594-35.363281s49.867188 13.21875 63.683594 35.363281l151 242c7.402344 11.863281 11.316406 25.570313 11.316406 39.636719 0 41.355469-33.644531 75-75 75zm0 0",
    fill: "#fff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m294.234375 81.246094c-8.300781-13.304688-22.59375-21.246094-38.234375-21.246094s-29.933594 7.941406-38.234375 21.242188l-150.996094 242c-4.492187 7.195312-6.769531 15.191406-6.769531 23.757812 0 24.8125 20.1875 45 45 45h302c24.8125 0 45-20.1875 45-45 0-8.566406-2.277344-16.558594-6.765625-23.757812zm112.765625 280.753906h-302c-8.269531 0-15-6.730469-15-15 0-2.90625.726562-5.480469 2.21875-7.878906l151-241.996094c2.785156-4.460938 7.5625-7.125 12.78125-7.125s10 2.664062 12.78125 7.128906l151 241.996094c1.492188 2.394531 2.21875 4.96875 2.21875 7.875 0 8.269531-6.730469 15-15 15zm0 0",
    fill: "#fff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m241 165h30v106h-30zm0 0",
    fill: "#fff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m241 301h30v30h-30zm0 0",
    fill: "#fff",
    "data-original": "#000000",
    style: {},
    className: ""
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProblemWhite);
export default __webpack_public_path__ + "static/media/problem_white.967dff1dc236d4a0798fc366e453eefa.svg";
export { ForwardRef as ReactComponent };